function initializeMaterialPDPScripts() {
    const productSections = document.querySelectorAll('.section__product-material__container');
    const productCards = document.querySelectorAll('.product-card');
    const kitBunchButton = document.querySelector('.section__product-material__kit-bunch.button');
    const kitBunchClearButton = document.querySelector('.kit-bunch__clear');
    const kitBunchContainer = document.querySelector('.kit-bunch__container');

    productSections.forEach((section) => {
        const swiperContainer = section.querySelector('.section__product-material__gallery .swiper');
        if (swiperContainer) {
            new Swiper(swiperContainer, {
                direction: 'horizontal',
                slidesPerView: 1,
                loop: true,
                navigation: {
                    nextEl: swiperContainer.querySelector('.swiper-arrow-right'),
                    prevEl: swiperContainer.querySelector('.swiper-arrow-left'),
                },
                scrollbar: {
                    el: swiperContainer.querySelector('.swiper-scrollbar'),
                    draggable: true,
                },
            });
        }
    });

    let kitBunchListCookie = Cookies.get('kitBunchListCookie');
    if (kitBunchListCookie) {
        const handleList = JSON.parse(kitBunchListCookie);
        updateSelectedItems(handleList);
    }

    if (kitBunchButton) {
        kitBunchButton.addEventListener('click', handleAddToKit);
    }

    if (kitBunchClearButton) {
        kitBunchClearButton.addEventListener('click', handleClearKit);
    }

    function updateSelectedItems(handleList) {
        productSections.forEach((section) => {
            const handle = section.getAttribute('data-handle');
            if (handleList.some(item => item['data-handle'] === handle)) {
                section.classList.add('selected');
            }
        });

        productCards.forEach((card) => {
            const handle = card.getAttribute('data-handle');
            if (handleList.some(item => item['data-handle'] === handle)) {
                card.classList.add('selected');
            }
        });

        handleList.forEach(item => {
            updateMaterialContainer(item);
        });

        if (kitBunchContainer) {
            kitBunchContainer.classList.add('visible');
        }
    }

    function handleAddToKit() {
        const section = document.querySelector('.section__product-material__container');
        const newItem = createItemFromSection(section);

        let updatedCookie = [];
        kitBunchListCookie = Cookies.get('kitBunchListCookie');
        if (kitBunchListCookie) {
            const existingValues = JSON.parse(kitBunchListCookie);
            if (!existingValues.some(item => item['data-handle'] === newItem['data-handle'])) {
                if (existingValues.length < 5) {
                    updatedCookie = [...existingValues, newItem];
                    Cookies.set('kitBunchListCookie', JSON.stringify(updatedCookie), { expires: 7, path: '/' });
                    updateMaterialContainer(newItem);
                    section.classList.add('selected');
                    document.querySelector(`.product-card[data-handle="${newItem['data-handle']}"]`)?.classList.add('selected');
                    document.querySelector('.drawer__tile-material')?.classList.remove('active');
                }
            }
        } else {
            updatedCookie = [newItem];
            Cookies.set('kitBunchListCookie', JSON.stringify(updatedCookie), { expires: 7, path: '/' });
            updateMaterialContainer(newItem);
            section.classList.add('selected');
            document.querySelector(`.product-card[data-handle="${newItem['data-handle']}"]`)?.classList.add('selected');
            document.querySelector('.drawer__tile-material')?.classList.remove('active');
        }
    }

    function handleClearKit() {
        Cookies.remove('kitBunchListCookie', { path: '/' });
        productSections.forEach((section) => section.classList.remove('selected'));
        productCards.forEach((card) => card.classList.remove('selected'));
        document.querySelectorAll('.kit-bunch__material-container').forEach((container) => {
            container.setAttribute('data-handle', '');
            container.setAttribute('data-title', '');
            container.setAttribute('data-sku', '');
            container.setAttribute('data-variant-id', '');
            container.querySelector('.kit-bunch__material-title').textContent = '';
            container.querySelector('.kit-bunch__material-src').innerHTML = '';
            container.classList.remove('visible');
        });
        if (kitBunchContainer) {
            kitBunchContainer.classList.remove('visible');
        }
    }

    function createItemFromSection(section) {
        return {
            'data-handle': section.getAttribute('data-handle'),
            'data-title': section.getAttribute('data-title'),
            'data-variant-id': section.getAttribute('data-variant-id'),
            'data-sku': section.getAttribute('data-sku'),
            'data-image': section.getAttribute('data-image')
        };
    }

    function updateMaterialContainer(item) {
        const container = document.querySelector('.kit-bunch__container');
        const materialContainer = document.querySelector(`.kit-bunch__material-container[data-handle="${item['data-handle']}"]`);

        if (!materialContainer) {
            const emptyContainer = document.querySelector('.kit-bunch__material-container[data-handle=""]');
            if (emptyContainer) {
                emptyContainer.setAttribute('data-handle', item['data-handle']);
                emptyContainer.setAttribute('data-title', item['data-title']);
                emptyContainer.setAttribute('data-sku', item['data-sku']);
                emptyContainer.setAttribute('data-variant-id', item['data-variant-id']);
                emptyContainer.querySelector('.kit-bunch__material-title').textContent = item['data-title'];
                emptyContainer.querySelector('.kit-bunch__material-src').innerHTML = `<img src="${item['data-image']}" alt="${item['data-title']}">`;
                emptyContainer.classList.add('visible');

                const removeButton = emptyContainer.querySelector('.kit-bunch__material-remove');
                removeButton.addEventListener('click', function () {
                    removeItemFromCookie(item['data-handle']);
                    emptyContainer.setAttribute('data-handle', '');
                    emptyContainer.setAttribute('data-title', '');
                    emptyContainer.setAttribute('data-sku', '');
                    emptyContainer.setAttribute('data-variant-id', '');
                    emptyContainer.querySelector('.kit-bunch__material-title').textContent = '';
                    emptyContainer.querySelector('.kit-bunch__material-src').innerHTML = '';
                    emptyContainer.classList.remove('visible');

                    document.querySelector(`.section__product-material__container[data-handle="${item['data-handle']}"]`)?.classList.remove('selected');
                    document.querySelector(`.product-card[data-handle="${item['data-handle']}"]`)?.classList.remove('selected');
                });
            }
        }

        if (container) {
            container.classList.add('visible');
        }
    }

    function removeItemFromCookie(handle) {
        const kitBunchListCookie = Cookies.get('kitBunchListCookie');
        if (kitBunchListCookie) {
            const updatedValues = JSON.parse(kitBunchListCookie).filter(item => item['data-handle'] !== handle);
            if (updatedValues.length > 0) {
                Cookies.set('kitBunchListCookie', JSON.stringify(updatedValues), { expires: 7, path: '/' });
            } else {
                Cookies.remove('kitBunchListCookie', { path: '/' });
            }
        }
    }
}

initializeMaterialPDPScripts();